/**
 * @file Reducer module for PickupForm Component
 * @author Mike Chacon
 */

import { combineReducers } from "redux";

import { reducerFactory } from "utils/createApiReducer";
import getPickupBlocks from "api/pickupBlocks";

let defaultState = {
  pickupDate: undefined,
  pickupBlock: undefined,
  hasFurniture: false,
  phoneNumber: undefined,
  zipCode: undefined,
  pickupLocation: undefined,
  step: 1,
  pickup: undefined,
  requireAcceptDonationGuidelines: undefined,
  newDonorFormComplete: false,
  addNewLocation: false,
  addNewDonor: false,
  forgotPassword: false,
  sentCode: false,
  isUsingInitialFlow: true,
  images: [],
  navigation: "none",
  pristine: true,
  notes: [],
};

const searchPickupBlocksReducer = reducerFactory(
  "SEARCH_PICKUP_BLOCKS",
  "pickupBlocks",
  false,
  false
);
const donorLocationsReducer = reducerFactory(
  "DONOR_LOCATIONS",
  "donorLocations",
  false,
  false
);

const dropOffLocationsReducer = (state = { dropOffLocations: [] }, action) => {
  switch (action.type) {
    case "SEARCH_PICKUP_BLOCKS_RECEIVED":
      return [...action.data.dropOff];
    case "SEARCH_PICKUP_BLOCKS_RESET":
      return { dropOffLocations: [] };
    default:
      return state;
  }
};

const donorWizard = (state = defaultState, action) => {
  switch (action.type) {
    case "NEXT_STEP":
      return { ...state, step: state.step + 1, navigation: "next" };

    case "PREVIOUS_STEP":
      return { ...state, step: state.step - 1, navigation: "previous" };

    case "ADD_FORM_DATA_TO_STORE":
      return { ...state, ...action.data, pristine: false };

    case "REMOVE_FORM_DATA_FROM_STORE":
      let resetStateValues = [];

      // Pass in array of keys that will be restored from the default state
      action.data.map((key) => {
        resetStateValues[key] = defaultState[key];
      });

      return { ...state, ...resetStateValues, pristine: false };

    case "RESET_FORM_DATA":
      return { ...defaultState };

    case "GO_TO_STEP":
      return { ...state, step: action.data || 1, navigation: "none" };

    case "ENTER_INITIAL_FLOW":
      return { ...state, isUsingInitialFlow: true };

    case "LEAVE_INITIAL_FLOW":
      return { ...state, isUsingInitialFlow: false };

    default:
      return state;
  }
};

export default combineReducers({
  formValues: donorWizard,
  pickupBlocks: searchPickupBlocksReducer,
  dropOffLocations: dropOffLocationsReducer,
  locations: donorLocationsReducer,
});

// export default donorWizard
